import { TickrService } from './../../../../shared/services/tickr/tickr.service';
import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UtilService } from '../../../../shared/services';
import { ICurrency } from '../../../../shared/models';
import { Subscription } from 'rxjs';
import { AcknowledgeFormComponent } from 'src/app/core/acknowledge-form/acknowledge-form.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-top-list',
  templateUrl: './top-list.component.html',
  styleUrls: ['./top-list.component.scss']
})
export class TopListComponent implements OnInit, OnDestroy {

  @Input() public fundraiser;
  @Input() public donors;
  @Input() public title;
  @Input() public icon;
  @Input() public cardType;
  @Input() public isFundraiserEnded;
  @Input() public isLoading;
  @Input() public donateBtnLabel;
  @Input() public settings;
  @Input() public type;
  @Input() public img;
  @Input() public view;
  isMobile: any;
  currencyInfo: ICurrency;
  currencySubscription: Subscription;
  isShowMore = false;
  donorsOrderBy = 'donated_amount';
  page = 1;
  fakeTickrSupportersCount: any;
  willTickrShow = false;
  tickrSubscription: Subscription[] = [];
  payment_option = {
    wallet: 'wallet',
    paytm: 'paytm',
    upi: 'upi',
    bank: 'bank'
  };
  @ViewChild('listContainer', { static: true }) listContainer: ElementRef;

  constructor(
    public utilService: UtilService,
    public dialog: MatDialog,
    private tickrService: TickrService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.fakeTickrSupportersCount = this.tickrService.reduceDonorsBy;
    // this.sendDonorListObject('donated_amount', 5, 1);
    this.getCurrency();
  }

  /**Toggle the show more */
  toggleShowMore() {
    this.isShowMore = !this.isShowMore;
    this.toggleClass();
  }
  /**Toggle class fpr shoe more */
  toggleClass() {
    const el: HTMLElement = this.listContainer.nativeElement;
    this.isShowMore ? el.classList.add('animate-container') : el.classList.remove('animate-container');
  }
  /**Sort the donor list */
  sortDonors(ordrby) {
    this.donorsOrderBy = ordrby;
    this.sendDonorListObject(ordrby, 5, 1);
  }
  /**get sort order by */
  getSortOrder(ordrby) {
    return this.donorsOrderBy === ordrby ? 'primary' : '';
  }
  navigateToSignIn() {
    const url = this.utilService.domain_details.domain_url + '/new/signin';
    this.utilService.nativeNavigation(url);
  }
  /**Send donor objec using observalble */
  sendDonorListObject(ordrby, limit, page) {
    const donorList = {
      orderby: ordrby,
      sortby: 'desc',
      limit: limit,
      page: page
    };
    this.utilService.donorList.next(donorList);
  }
  /**pagination */
  setPagination(pageAction) {
    if (pageAction === 'next') {
      this.sendDonorListObject(this.donorsOrderBy, 5, ++this.page);
    } else {
      if (this.page >= 1) {
        this.sendDonorListObject(this.donorsOrderBy, 5, --this.page);
      }
    }
  }
  ackPopup() {
    this.dialog.open(AcknowledgeFormComponent, {
      data: { mode: this.payment_option.paytm },
      width: '100vw',
      height: '100vh',
      maxWidth: '600px',
      maxHeight: this.isMobile ? '100vh' : '550px',
    });
  }
  /**
   * Get the currency of the from
   * currency observable
  */
  getCurrency() {
    this.currencySubscription = this.utilService.currency.subscribe({
      next: (res) => {
        if (res) {
          this.currencyInfo = this.utilService.getCurrencyIcon(res);
        }
      }
    });
  }

  ngOnDestroy() {
  }

}
